<template>
    <div ref="layout" class="masonry-layout" :style="{
        gridTemplateColumns: 'repeat(auto-fill, calc('+props.itemWidth+' + '+ props.gutter + '))',
        gridGap: '0',
        marginTop: '-'+props.gutter,
        marginLeft: '-'+props.gutter,
    }">
        <transition-group name="fade"
                          enter-active-class="animate__animated animate__fadeInUp">
            <div class="masonry-item masonry__item" v-for="(item, index) in items"
                 :style="{paddingLeft: props.gutter,paddingTop: props.gutter}"
                 :key="index">
                <slot name="item" :item="item" :index="index"></slot>
            </div>
        </transition-group>
    </div>
</template>

<script setup lang="ts">
import {nextTick, onBeforeUnmount, onMounted, ref, watch} from "vue";

import MasonrySimple from "masonry-simple";
import {debounce} from "lodash";

const props = withDefaults(defineProps<{
    gutter?: string | number,
    items?: any[],
    itemWidth?: string | number,
}>(), {
    gutter: '10px',
    items: [] as any,
    itemWidth: '200px'
})

const layout = ref<HTMLElement>()
const items = ref(props.items)

watch(() => props.items, () => {
    items.value = props.items
    nextTick(() => {
        resize()
    })
})

const resize = () => {
    MasonrySimple.init({
        container: layout.value
    })
}

const debounceResize = debounce(resize, 200)

onMounted(() => {
    resize()

    window.addEventListener('resize', debounceResize)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', debounceResize)
})
</script>

<style scoped lang="less">
.masonry-layout {
    width: 100%;
    display: grid;
    grid-auto-flow: dense;
    place-content: center;
}
</style>
